import React, {useEffect} from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout";
import BlogPostContent from "../components/BlogPostContent/BlogPostContent";
import MainPageHeader from "../components/MainPageHeader/MainPageHeader";
import MetaHead from "../components/MetaHead";

export default function Template({ pageContext, data }) {


  // const { allGhostPost: rPosts } = data;
  const { post } = pageContext;

  // let recentPosts = [...rPosts.edges];

  // const currentPostIdx = recentPosts.findIndex((r) => {
  //   return post.id === r.node.id;
  // });

  // if (currentPostIdx > -1) {
  //   recentPosts.splice(currentPostIdx, 1);
  // }
  // recentPosts.length = 4;

  let x = post.html;
  let extractscript = '';
  if (x) { 
    extractscript=/<script(?: type='text\/javascript')?>(.+)<\/script>/gim.exec(x);
    if (extractscript && extractscript[0]) {
      x=x.replace(extractscript[0],"");
    }
  }

  if (x) { 
    extractscript=/<iframe width="[0-9]+" height="[0-9]+" src="https:\/\/www.youtube.com\/embed/gim.exec(x);
    if (extractscript && extractscript[0]) {
      x=x.replaceAll(extractscript[0],'<iframe width="100%" height="350" src="https://www.youtube.com/embed');
    }
  }

  if (x) { 
    extractscript=/<a href="/gim.exec(x);
    if (extractscript && extractscript[0]) {
      x=x.replaceAll(extractscript[0],'<a target="_blank" href="');
    }
  }
  
  useEffect(() => {
    if (extractscript && extractscript[1]) {
      /* eslint-disable */
      window.eval(extractscript[1]);/* eslint-enable */
    }
  }, [extractscript])

  return (
    <Layout>
      <MainPageHeader 
          title={<div className="text-[24px] md:text-[45px] leading-[45px]">{post.title}</div>} 
          image={"https://content.theinformationlab.co.uk/images/hero_insights_65c4fb858c.png"}
          gatsbyImage={data?.page?.HeroImage?.localFile?.childImageSharp?.gatsbyImageData}
          backLabel={"The Blog"}
          backLink={-1}
          accentColour={'blue'}
          small={true}
        />
        <BlogPostContent 
          html={x} 
          meta={{
            authors: post.authors,
            postType: 'Blog',
          }} />
    </Layout>
  )
}

export const Head = ({pageContext}) => <MetaHead 
                                  title={`${pageContext?.post?.title} - The Data School`}
                                  description={pageContext?.post?.excerpt?.replace(/(<([^>]+)>)/gi, "")}
                                  image={pageContext?.post?.feature_image}
                                />

export const pageQuery = graphql`
  query BlogHeader {
    page: strapiDsWwwPage(slug: {eq: "blog"}) {
      HeroImage {
        url
        localFile {
          childImageSharp {
            gatsbyImageData(height: 360, formats: WEBP, placeholder: BLURRED)
          }
        }
      }
    }
  }
`
